const PbxxRecord = require('../pbxx_record')

module.exports = class Asset extends PbxxRecord {
  static get class_name() {
    return 'Asset'
  }

  get get_digital_asset() {
    return this.digital_asset ? this.digital_asset : null
  }
}
